<p-confirmdialog />
<p-toast />
<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">Customers</h1>
          <p class="text-sm text-primary-500">View all of Your Clients Information</p>
        </div>
        <div class="flex gap-2">
          <p-button icon="pi pi-download" label="Export" severity="secondary"></p-button>
          <p-button icon="pi pi-plus" label="Add New" severity="primary" (onClick)=" addCustomer()"></p-button>
        </div>
      </div>
      
      <!-- Tabs -->
      <p-tabMenu [model]="tabs" [activeItem]="activeTab" class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
      <p-table
        #dt2
        [columns]="cols"
        dataKey="id"
        stripedRows
        [value]="filtered_customers()!"
        [scrollable]="true"
        [resizableColumns]="true"
        [autoLayout]="true"
        [paginator]="true"
        [globalFilterFields]="[
          'first_name',
          'last_name',
          'status',
          'autopay_status',
          'mailing_address.line1'
        ]"
        [rows]="25"
        selectionMode="multiple"
        (selectionChange)="selectionChanged($event)"
        [(selection)]="selectedCustomers"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #emptymessage>
          <tr>
            <td colspan="8">No customers found.</td>
          </tr>
        </ng-template>

        <ng-template #caption>
          <div class="flex">
            <p-iconfield iconPosition="left">
              <p-inputicon>
                  <i class="pi pi-search"></i>
              </p-inputicon>
              <input pInputText class="ml-10 w-full" type="text" (input)="filter($event, dt2)" placeholder="Search keyword" />
          </p-iconfield>
          <p-button class="ml-auto" label="Clear" [outlined]="true" icon="pi pi-filter-slash" (click)="clear(dt2)" />
          </div>
      </ng-template>
              <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th class="w-2"><p-tableHeaderCheckbox /></th>
            <th pResizableColumn pSortableColumn="first_name">
              First Name
              <p-sortIcon field="first_name" />
            </th>
            <th pResizableColumn pSortableColumn="last_name">
              Last Name
              <p-sortIcon field="last_name" />
            </th>
            <th pResizableColumn pSortableColumn="status">
              Status
              <p-sortIcon field="status" />
            </th>
            <th pResizableColumn pSortableColumn="mailing_address.line1">
              Address
              <p-sortIcon field="mailing_address.line1" />
            </th>
            <th pSortableColumn="autopay_status">
              Autopay
              <p-sortIcon field="autopay_status" />
            </th>
            <th
              pResizableColumn
              pSortableColumn="subscriptions_total"
              style="text-align: right">
              Monthly $
              <p-sortIcon field="subscriptions_total" />
            </th>
            <th
              pResizableColumn
              pSortableColumn="current_balance"
              style="text-align: right">
              Balance
              <p-sortIcon field="current_balance" />
            </th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td>
              <p-tableCheckbox [value]="rowData" />
          </td>
            <td>
              <span>
                {{ rowData.first_name }}
            </span>
          </td>
            <td>
              {{ rowData.last_name }}
            </td>
            <td>
              <span [ngClass]="rowData.status === 'ACTIVE' ? 'green' : 'red'">
                {{ rowData.status }}
              </span>
            </td>
            <td>
              {{ rowData.mailing_address?.line1 }}
            </td>
            <td>
              <span [ngClass]="rowData.autopay_status ? 'green' : 'red'">
                {{ rowData.autopay_status | boolToText }}
              </span>
            </td>
            <td style="text-align: right">
              {{ rowData.subscriptions_total | currency : "USD" }}
            </td>
            <td style="text-align: right">
              {{ rowData.current_balance | currency : "USD" }}
            </td>
            <td>
              <p-button
                (click)="menuClicked(rowData); menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="row_items" [popup]="true" />
    </div>
    <div class="w-full m-4">
      <p-button
        class="w-2 p-3 rounded-md bg-primary-500"
        label="Send Email"
        [disabled]="!this.selectedCustomers() || this.selectedCustomers()!.length < 1"
        (click)="sendEmail()" />
    </div>
  </block-ui>
</div>

<app-subscription-change-plan-modal
  (onData)="handleData($event)"
  [objectType]="objectType"
  [objectId]="objectId"
  [visible]="changePlanVisible"></app-subscription-change-plan-modal>
<app-subscription-change-price-modal
  (onData)="handleData($event)"
  [objectType]="objectType"
  [objectId]="objectId"
  [visible]="changePriceVisible"></app-subscription-change-price-modal>
<p-dialog
  header="Send Email"
  [modal]="true"
  [(visible)]="dialogVisible"
  [style]="{ width: '1000px' }">
  <app-mass-email
    (visibilityChanged)="changeVisibility($event)"
    [selectedCustomers]="nettCustomers"></app-mass-email>
</p-dialog>
